import { render, staticRenderFns } from "./Actscore.vue?vue&type=template&id=b3ecc09e&scoped=true"
import script from "./Actscore.vue?vue&type=script&lang=js"
export * from "./Actscore.vue?vue&type=script&lang=js"
import style0 from "./Actscore.vue?vue&type=style&index=0&id=b3ecc09e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ecc09e",
  null
  
)

export default component.exports